'use strict';

var favouritesapp = angular.module("favouritesapp", []);

favouritesapp.factory('httpRequestInterceptor', function () {
    return {
        request: function (config) {
            if (config.url.indexOf("/api/") === 0) {
                if (window.current_location != null) {
                    config.headers['current-location'] = window.current_location;
                } else {
                    GetCurrentUserLocation(function (coordinates) {
                        config.headers['current-location'] = window.current_location;
                    });
                }
            }
            return config;
        }
    };
});

favouritesapp.config(function ($locationProvider, $httpProvider) {
    $locationProvider.html5Mode({
        enabled: true,
        requireBase: true
    });
    $httpProvider.interceptors.push('httpRequestInterceptor');
});

(function () {
    'use strict';

    favouritesapp.service("dataService", dataService);
    dataService.$inject = ['$http', '$q'];
        
    favouritesapp.controller("favouritesCtrl", favouritesCtrl);
    favouritesCtrl.$inject = ['dataService', '$timeout', '$window'];

    function favouritesCtrl(dataService, $timeout, $window) {
        var vm = this;        
        vm.showMoreLocations = showMoreLocations;        
        vm.removeMerchant = removeMerchant;
        vm.setMerchantToRemove = setMerchantToRemove;
        
        init();

        function setMerchantToRemove(merchant) {
            vm.currentMerchant = merchant;
            $(".confirm-remove-modal").modal({
                backdrop: "static"
            });
        }

        function removeMerchant(merchantID) {
            dataService.removeFromFavourites(merchantID).then(function () {
                for (var i = vm.data.length; i--;) {
                    for (var y = vm.data[i].Merchants.length; y--;) {
                        if (vm.data[i].Merchants[y].Merchant.MerchantID === merchantID) {
                            vm.data[i].Merchants.splice(y, 1);

                            if (vm.data[i].Merchants.length === 0) {
                                vm.data.splice(i, 1);
                            }
                        }
                    }
                }                
            });
        }

        function showMoreLocations(item) {
            item.showMoreHidden = true;
        }
        
        function loadData(q) {
            
            var req = dataService.myFavourites();
            handlePendingRequests(vm, "myFavourites", req);

            req.promise.then(function (res) {
                vm.data = res.data.Data;                
            });
        }       

        function loadCurrentUserLocation() {
            GetCurrentUserLocation(function (loc) {
                if (loc != null) {
                    var sp = loc.split(',');
                    vm.UserCurrentLocation = {
                        Latitude: parseFloat(sp[0]),
                        Longitude: parseFloat(sp[1])
                    };
                    loadData();
                }
            });
        }

        function init() {
            loadCurrentUserLocation();
            //wait if we can got user current location
            $timeout(function () {
                if (vm.UserCurrentLocation == null) {
                    loadData();
                }
            }, 200);

            $window.onfocus = function () {
                $timeout(function () {
                    if (vm.UserCurrentLocation == null) {
                        loadCurrentUserLocation();
                    }

                }, 200);
            };
        }
    };
})();

